import {CardRendererResponseBody, RendererProps} from 'platform/components';
import {match} from 'ts-pattern';

import {always, isNotNil} from 'ramda';

import i18n from '@dms/i18n';

const trueRegex = /{{\s*true\s*}}/;
const falseRegex = /{{\s*false\s*}}/;

// Recursively update renderer properties supplied by the frontend.
export const parsedRendererProps = (
  schema: RendererProps,
  recommendedFieldNames: string[] = []
): RendererProps => {
  if (schema.renderer === 'select' && schema.defaultOptions) {
    const updatedOptions = schema.defaultOptions.map((option) => ({
      ...option,
      label: match(option.label)
        .when((label) => trueRegex.test(label), always(i18n.t('general.labels.yes')))
        .when((label) => falseRegex.test(label), always(i18n.t('general.labels.no')))
        .otherwise(() => option.label),
    }));
    return markRecommended({...schema, defaultOptions: updatedOptions}, recommendedFieldNames);
  }

  // Recursively update nested elements
  if (hasSchemaChildElements(schema)) {
    const updatedElements = schema.elements.map((element) =>
      parsedRendererProps(element, recommendedFieldNames)
    );
    return markRecommended(
      {...schema, elements: updatedElements} as RendererProps,
      recommendedFieldNames
    );
  }

  return markRecommended(schema, recommendedFieldNames);
};

const markRecommended = (schema: RendererProps, recommendedFieldNames: string[]): RendererProps => {
  const isRequired =
    'rules' in schema &&
    Array.isArray(schema.rules) &&
    schema.rules.some((rule) => rule.type === 'required' && rule.value);

  return isRequired || recommendedFieldNames.includes(schema.name)
    ? {...schema, isRecommended: true}
    : schema;
};

const hasSchemaChildElements = (
  schema: RendererProps
): schema is RendererProps & {elements: RendererProps[]} =>
  isNotNil((schema as CardRendererResponseBody).elements);
